import { createSlice } from '@reduxjs/toolkit';

import { noop } from '@constants/general';

export const initialState = {
  model: {
    list: [],
    options: {
      filingTypes: [],
    },
  },
  meta: {
    hasError: false,
    isLoading: true,
    isOptionsLoading: false,
    isUpdating: false,
  },
};

const filingTypes = createSlice({
  name: 'filingTypes',
  initialState,
  reducers: {
    filingTypesReset: noop,
    filingTypesFetchStart: state => {
      state.meta.isLoading = true;
      state.meta.isUpdating = false;
      state.meta.hasError = false;
    },
    filingTypesFetchSuccess: (state, { payload = {} }) => {
      state.model.list = payload.data;
      state.meta.isLoading = false;
      state.meta.isUpdating = false;
      state.meta.hasError = false;
    },
    filingTypesFetchFailure: state => {
      state.model.list = [];
      state.meta.isLoading = false;
      state.meta.isUpdating = false;
      state.meta.hasError = true;
    },
    filingTypesCreateStart: state => {
      state.meta.hasError = false;
    },
    filingTypesCreateSuccess: noop,
    filingTypesCreateFailure: noop,
    filingTypesUpdateStart: state => {
      state.meta.hasError = false;
    },
    filingTypesUpdateSuccess: noop,
    filingTypesUpdateFailure: noop,
    filingTypesDeleteStart: state => {
      state.meta.hasError = false;
      state.meta.isUpdating = true;
    },
    filingTypesDeleteSuccess: state => {
      state.meta.isUpdating = false;
    },
    filingTypesDeleteFailure: state => {
      state.meta.isUpdating = false;
    },
    filingTypesOptionsFetchStart: state => {
      state.meta.isOptionsLoading = true;
      state.meta.hasError = false;
    },
    filingTypesOptionsFetchSuccess: (state, { payload = {} }) => {
      state.model.options = payload;
      state.meta.isOptionsLoading = false;
      state.meta.hasError = false;
    },
    filingTypesOptionsFetchFailure: state => {
      state.model.options = initialState.model.options;
      state.meta.isOptionsLoading = false;
      state.meta.hasError = true;
    },
  },
});

export const {
  filingTypesReset,
  filingTypesFetchStart,
  filingTypesFetchSuccess,
  filingTypesFetchFailure,
  filingTypesCreateStart,
  filingTypesCreateSuccess,
  filingTypesCreateFailure,
  filingTypesUpdateStart,
  filingTypesUpdateSuccess,
  filingTypesUpdateFailure,
  filingTypesDeleteStart,
  filingTypesDeleteSuccess,
  filingTypesDeleteFailure,
  filingTypesOptionsFetchStart,
  filingTypesOptionsFetchSuccess,
  filingTypesOptionsFetchFailure,
} = filingTypes.actions;
export default filingTypes.reducer;
